var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{class:_vm.computedClass},[_vm._t("default",function(){return [_c('span',[_vm._v("no_content")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }